/**
 * Central route-constants file.
 *
 * Every internal `navigate(...)` or `<Link to="...">` in the app should
 * import from here so we never scatter hard-coded URLs. This is also
 * what the route-integrity smoke test iterates over.
 *
 * Hotfix · Feb 2026 — introduced together with the branded route
 * error boundary and catch-all `NotFoundPage` so route drift can be
 * detected instantly.
 */
export const ROUTES = {
  // ── Public marketing ───────────────────────────────────────
  landing:       "/",
  product:       "/product",
  howItWorks:    "/how-it-works",
  workflow:      "/workflow",
  capabilities:  "/capabilities",
  contact:       "/contact",
  aboutUs:       "/about-us",
  careers:       "/careers",
  support:       "/support",
  privacy:       "/privacy",
  faq:           "/faq",
  resources:     "/resources",
  blog:          "/blog",
  caseStudies:   "/case-studies",
  docs:          "/docs",

  // ── Auth ────────────────────────────────────────────────────
  login:          "/login",
  signup:         "/signup",
  forgotPassword: "/forgot-password",
  changePassword: "/change-password",

  // ── Protected workspace ─────────────────────────────────────
  app:            "/app",
  dashboard:      "/app",                 // dashboard === workspace root
  projects:       "/app",                 // canonical listing view
  portfolio:      "/app/portfolio",
  newProject:     "/app/projects/new",
  project:        (pid)  => `/app/projects/${pid}`,
  projectSetup:   (pid)  => `/app/projects/${pid}/setup`,
  projectWizard:  (pid)  => `/app/projects/${pid}/wizard/project_setup`,
  wizardStep:     (pid, step) => `/app/projects/${pid}/wizard/${step}`,
  projectCockpit: (pid)  => `/app/projects/${pid}/cockpit`,
  projectHealth:  (pid)  => `/app/projects/${pid}/health`,
  projectCPR:     (pid)  => `/app/projects/${pid}/wizard/cpr`,
  reportReadiness: (pid) => `/app/projects/${pid}/health`,

  // ── Admin ───────────────────────────────────────────────────
  superadmin:              "/app/superadmin",
  superadminUsers:         "/app/superadmin/users",
  superadminCompanies:     "/app/superadmin/companies",
  superadminProjects:      "/app/superadmin/projects",
  superadminPending:       "/app/superadmin/pending",
  superadminAudit:         "/app/superadmin/audit",
  superadminRoles:         "/app/superadmin/roles",
  superadminPermissions:   "/app/superadmin/permissions",
  superadminInvitations:   "/app/superadmin/invitations",
  adminInbox:              "/app/admin/inbox",
  companyAdmin:            "/app/company-admin",
};

/**
 * Human-readable name for each canonical route. Used by the branded
 * 404/error pages when suggesting "you probably meant …" links.
 */
export const ROUTE_LABELS = {
  "/":                    "Landing",
  "/app":                 "Workspace",
  "/app/portfolio":       "Portfolio",
  "/app/projects/new":    "Start new project",
  "/app/superadmin":      "Management Console",
  "/login":               "Sign in",
  "/support":             "Support",
};
